// ProductDetailsModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useCart } from './CartContext';

// Helper to turn weight+uom into a friendly string
function formatWeight({ weight, uom }) {
  if (uom === 'oz') {
    return `${weight} oz`;
  }
  // assume pounds: show "X lb" or "X lb Y oz"
  const lbs = Math.floor(weight);
  const oz = Math.round((weight - lbs) * 16);
  if (oz > 0) {
    return `${lbs} lb ${oz} oz`;
  }
  return `${lbs} lb`;
}

function ProductDetailsModal({ show, handleClose, product }) {
  const { addToCart } = useCart();
  if (!product) return null;

  const price = parseFloat(product.price);
  const salePrice = product.salePrice ? parseFloat(product.salePrice) : null;
  const weightStr = formatWeight(product);

  // Check if the product is a "Feature" item
  const isFeatureItem = product.type === 'Feature';

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{product.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Zoom>
          <img src={product.image} alt={product.name} className="img-fluid mb-3" />
        </Zoom>
        {product.image2 && (
          <Zoom>
            <img src={product.image2} alt={`${product.name} - 2`} className="img-fluid mb-3" />
          </Zoom>
        )}
        {product.image3 && (
          <Zoom>
            <img src={product.image3} alt={`${product.name} - 3`} className="img-fluid mb-3" />
          </Zoom>
        )}

        {salePrice ? (
          <p>
            <strong>Price:</strong>{' '}
            <span className="text-muted text-decoration-line-through">
              ${price.toFixed(2)}
            </span>{' '}
            <span className="text-danger">
              ${salePrice.toFixed(2)}
            </span>
          </p>
        ) : (
          <p><strong>Price:</strong> ${price.toFixed(2)}</p>
        )}

        {product.size && <p><strong>Size:</strong> {product.size}</p>}

        {/* New weight display */}
        {product.weight != null && product.uom && (
          <p><strong>Weight:</strong> {weightStr}</p>
        )}

        {/* Display the product type */}
        {product.type && <p><strong>Type:</strong> {product.type}</p>}

        <p>{product.description}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        {/* Disable Add to Cart button if it's a feature item */}
        {!product.sold && !isFeatureItem && (
          <Button
            variant="primary"
            onClick={() => {
              addToCart(product);
              handleClose();
            }}
          >
            Add to Cart
          </Button>
        )}
        {isFeatureItem && (
          <p>This product is a featured item and cannot be added to the cart.</p>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ProductDetailsModal;

